import styled from 'styled-components'
import { map, prop } from 'ramda'
import noop from 'lodash/noop'

import { breakpoints } from '@/styles'
import sortByPosition from '@/utils/sort-by-position'
import { toUnit } from '@/utils/styles'
import CdnImage from '@/components/cdn-image'
import { PhotoSlider } from '@/components/photo-slider'

import defaultImage from './default-building.jpg'

const PhotoSliderContainer = styled.div`
  top: 0;
  left: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-top-left-radius: ${props => toUnit(props.borderRadius)};
  border-bottom-left-radius: ${props =>
    props.isRow && toUnit(props.borderRadius)};
  border-top-right-radius: ${props =>
    !props.isRow && toUnit(props.borderRadius)};
  animation: fadeIn ease-in-out 0.2s;

  @keyframes fadeIn {
    0% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .slick-slider {
    height: 100%;

    .slick-list {
      height: 100%;

      .slick-track {
        height: 100%;
      }
    }
  }

  .slick-slide > div {
    line-height: 0;
    height: 100%;
  }

  .photo-carousel-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  button {
    transition: opacity 0.2s ease-in-out;
    opacity: 0.5;
    :hover {
      opacity: 0.5 !important;
    }
  }

  @media (min-width: ${breakpoints.phoneMax}) {
    button {
      :hover {
        opacity: 1 !important;
      }
    }
  }
`

const BackgroundPhotoSlider = ({
  images = [],
  borderRadius = 12,
  imageFilter,
  placeholder = 'shimmer',
  sizes = '345px',
  setCurrentPhotoIndex = noop,
  isRow,
  altText = ''
}) => {
  const sortedImages = sortByPosition(images)

  const plainImages = map(prop('aws_s3_key'), sortedImages)

  const getSliderSettings = imageFiles => {
    const showThings = imageFiles.length > 1

    const settings = {
      dots: false,
      infinite: showThings,
      arrows: showThings,
      swipeToSlide: showThings,
      swipe: showThings,
      initialSlide: 0,
      slidesToShow: 1,
      beforeChange: (_, newIndex) => {
        setCurrentPhotoIndex(newIndex + 1)
      }
    }

    return settings
  }

  const shouldRenderSlider = plainImages?.length > 1
  const coverImage = plainImages[0] || defaultImage
  return (
    <PhotoSliderContainer
      imageFilter={imageFilter}
      borderRadius={borderRadius}
      isRow={isRow}
    >
      {shouldRenderSlider ? (
        <PhotoSlider
          images={plainImages}
          {...getSliderSettings(sortedImages)}
          placeholder={placeholder}
          sizes={sizes}
          enableClickPropagation
          altText={altText}
        />
      ) : (
        <CdnImage
          src={coverImage}
          sizes={sizes}
          layout="fill"
          objectFit="cover"
          placeholder={placeholder}
          alt={altText}
        />
      )}
    </PhotoSliderContainer>
  )
}

export default BackgroundPhotoSlider
